import { AI_ASSISTANT_CONSTANTS } from "../constants/aiAssistantConstants";
import { createRandomId } from "./randomId";

const { HANDOFF } = AI_ASSISTANT_CONSTANTS;
const HANDOFF_PREFIX = HANDOFF.PREFIX;
const HANDOFF_QUERY_KEY = HANDOFF.QUERY_KEY;

export const createHandoffName = (conversationId) => {
  if (!conversationId) return null;
  const nonce = createRandomId("nonce");
  return `${HANDOFF_PREFIX}${conversationId}|${nonce}`;
};

export const consumeHandoffName = () => {
  if (typeof window === "undefined") return null;
  const name = window.name || "";
  if (!name.startsWith(HANDOFF_PREFIX)) return null;
  const payload = name.slice(HANDOFF_PREFIX.length);
  const conversationId = payload.split("|")[0];
  try {
    window.name = "";
  } catch (error) {
    console.warn("[AI Assistant] Failed to clear window.name", error);
  }
  return conversationId || null;
};

export const consumeHandoffParam = () => {
  if (typeof window === "undefined") return null;
  try {
    const url = new URL(window.location.href);
    const conversationId = url.searchParams.get(HANDOFF_QUERY_KEY);
    if (!conversationId) return null;
    url.searchParams.delete(HANDOFF_QUERY_KEY);
    window.history.replaceState(null, "", url.toString());
    return conversationId;
  } catch (error) {
    console.warn("[AI Assistant] Failed to read handoff param", error);
  }
  return null;
};

export const appendHandoffParam = (rawLink, conversationId) => {
  if (typeof window === "undefined" || !rawLink || !conversationId) return rawLink;
  try {
    const url = rawLink.startsWith("http")
      ? new URL(rawLink)
      : new URL(rawLink, window.location.origin);
    if (url.origin !== window.location.origin) return rawLink;
    url.searchParams.set(HANDOFF_QUERY_KEY, conversationId);
    return url.toString();
  } catch (error) {
    return rawLink;
  }
};

const shouldSkipLinkEvent = (event) => {
  if (!event) return false;
  if (event.button && event.button !== 0) return true;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return true;
  return false;
};

export const openAssistantLink = (
  rawLink,
  conversationId,
  {
    event,
    target = HANDOFF.DEFAULT_TARGET,
    features = HANDOFF.DEFAULT_FEATURES,
  } = {},
) => {
  if (typeof window === "undefined" || !rawLink) return;
  if (shouldSkipLinkEvent(event)) return;
  if (event?.preventDefault) {
    event.preventDefault();
  }

  try {
    const url = rawLink.startsWith("http")
      ? new URL(rawLink)
      : new URL(rawLink, window.location.origin);
    if (url.origin === window.location.origin && conversationId) {
      url.searchParams.set(HANDOFF_QUERY_KEY, conversationId);
      const handoffName = createHandoffName(conversationId) || target;
      window.open(url.toString(), handoffName, features);
      return;
    }
    window.open(url.toString(), target, features);
  } catch (error) {
    const fallbackLink = appendHandoffParam(rawLink, conversationId);
    window.open(fallbackLink, target, features);
  }
};
